import { render, staticRenderFns } from "./Saidao4.vue?vue&type=template&id=048149eb&scoped=true&"
import script from "./Saidao4.vue?vue&type=script&lang=js&"
export * from "./Saidao4.vue?vue&type=script&lang=js&"
import style0 from "./Saidao4.vue?vue&type=style&index=0&id=048149eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048149eb",
  null
  
)

export default component.exports